<template><div><h1 id="aktionsauswertung-projektfinanzierer" tabindex="-1"><a class="header-anchor" href="#aktionsauswertung-projektfinanzierer"><span>Aktionsauswertung Projektfinanzierer</span></a></h1>
<p>Aktionsauswertung Projektfinanzierer — Aktionsauswertung mit Gruppierung nach Projektfinanzierer</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung listet Beträge (pro Gönner/Projektfinanzierer), aufgeteilt nach Aktionen aus. Optional kann die Auswahl eingeschränkt werden, z.B. nach Zeitraum, Projekten, Projektstatus usw.. Das Resultat lässt sich nach verschiedenen Kriterien gruppieren.</p>
<p>Pfad: <code v-pre>Projektfinanzierung → Auswertungen → Aktionsauswertung Projektfinanzierer</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Auswertung</dt>
<dd>Abgrenzung des Zeitraums nach Projektperiode oder Datum. Abhängig von der Eingabe werden spezifische Erfassungsfelder geöffnet.</dd>
<dt>Periode von/bis</dt>
<dd>Berücksichtigt nur Aktionen mit Eintrag der Projektperiode innerhalb dieses Bereiches.</dd>
<dt>(Aktions-)Datum von/bis</dt>
<dd>Berücksichtigt nur Aktionen mit Aktionsdatum innerhalb dieses Datumbereiches.</dd>
<dt>nur aktive Projekte (Checkbox)</dt>
<dd>Es werden nur Projekte mit Status &quot;aktiv&quot;, &quot;bewilligt&quot; und &quot;finanziert&quot; berücksichtigt.</dd>
<dt>nur Projekte mit Umsatz anzeigen (Checkbox)</dt>
<dd>Es werden nur Projekte berücksichtigt, die mindesetens 1 Aktion mit Betrag aufweisen.</dd>
<dt>Gruppierung</dt>
<dd>&quot;keine&quot; (Ausgabe in Excel als &quot;flache&quot; Tabelle), &quot;nach Projekt&quot;, &quot;nach Projektfinanzierer&quot;, &quot;nach Bransche&quot;</dd>
<dt>Projekte</dt>
<dd>Einschränkung auf ein oder mehrere Projekte, * = alle</dd>
<dt>Ausgabe</dt>
<dd>Birt</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe ist abhängig von der gewählten Gruppierung. Zu jedem Gönner/Projektfinazierer wird pro Projekt der Betrag eingereicht/abgelehnt/bewilligt und überwiesen angezeigt.</p>
</div></template>


